module.exports = __webpack_public_path__ + "img/ic_pdf.1a3e2e73.svg";